<template>
  <div>
    <TheError v-if="error.show" :text="error.text" />
    <TheLoading :visible="isLoading" />
    <!-- 真正的内容区域，包含背景图 -->
    <div class="extension-signup-content">
      <!-- 端上导航头（返回、分享） -->
      <HeaderNav
        v-if="$isInApp"
        :info="{ isIndexHead: true }"
        isHomePage
        @share="handleSharePoint"
      />
      <!-- 免登录提示 -->
      <LoginFreeTips v-if="$isLoginFree" />
      <!-- 活动名称/活动时间/续报规则 -->
      <ActivityTitle
        v-if="$$(contCourseData.cnt_describe)"
        :title-info="contCourseData"
      />
      <!-- 中心多选区域内容 -->
      <div
        v-if="(stateIsLogin || $isLoginFree) && loadCoursePackageEnding"
        class="extension-signup-content-list"
      >
        <!-- 已登陆，无任何列表数据-->
        <SwitchAccount
          :contCourseData="contCourseData"
          :isLogin="stateIsLogin"
          :phone="phone"
          @handleLoginPop="handleLoginPop"
          @handleLogout="handleLogout"
        />
        <div>
          <course-tab-list
            v-if="$$(contCourseData.cnt_list).length > 0"
            :courseTabList="contCourseData.cnt_list"
            cardType="raw"
            :showExpand="showExpand"
          />
          <!-- 推荐课程 -->
          <course-tab-list
            v-if="$$(contCourseData.recom_list).length > 0"
            :courseTabList="contCourseData.recom_list"
            showTitle
            cardType="recom"
          />
        </div>
      </div>
    </div>
    <!-- 底部-->
    <PageFooter
      v-if="
        $$(contCourseData.cnt_list).length > 0 ||
        $$(contCourseData.recom_list).length > 0
      "
      :check-data="checkData"
      :disabled-buy="disabledBuy"
      :is-disabled="disabledSelectAll"
      :list="contCourseData"
      :showClashTip="showClashTip"
      :discount="discount"
      :isLoading="isLoading"
      :mustCheckBtn="mustCheckBtn"
      @buy="goBuy"
      @buyOld="buyOld"
      @selectAll="handleCheckAll"
      @close-clash-tip="showClashTip = false"
    />
    <Dialog
      :contents="dialog.contents"
      :title="dialog.title"
      :visible.sync="dialog.show"
    />
  </div>
</template>

<script>
import TheError from "@/components/TheError";
import TheLoading from "@/components/TheLoading";
import HeaderNav from "@/components/headerNav";
import SwitchAccount from "@/components/SwitchAccount";
import courseTabList from "./components/courseTabList.vue";
import ActivityTitle from "./components/activityTitle";
import WXJsBridge from "@xes/wxjsbridge/src";
import PageFooter from "./components/footer";
import Dialog from "@/components/Dialog"; // 弹框
import LoginFreeTips from "./components/loginFreeTips";
import {
  getContCourseIndex,
  postCheckIndex,
  idEncode,
  postIsCanBuy,
  getAddPriceBuyList,
} from "@/api/api";
import { loginPopUp, logout } from "./utils/login";
import { cloneDeep } from "lodash";
import {
  formatData,
  setSelectType,
  positionCard,
  setBuyPrice,
  transfromGoodsInfo,
} from "./utils/formatData";
import mockData from "./mock/new";
import {
  singleSelectPoint,
  selectAllPoint,
  sharePoint,
  loadPoint,
} from "./utils/point";
import { mapActions, mapMutations, mapState } from "vuex";
import { getAllRecomIdObj } from "./utils/tool";
import { v4 as uuidv4 } from "uuid";
import {
  appendStuCourseIds,
  setStuCourseIds,
} from "@/common/script/log-helper";

export default {
  provide() {
    return {
      listType: "common", // 当为common时存在选择框
      getCurrentDiscount: () => this.discount,
    };
  },
  components: {
    HeaderNav,
    TheError,
    TheLoading,
    PageFooter,
    ActivityTitle,
    Dialog,
    SwitchAccount,
    courseTabList,
    LoginFreeTips,
  },
  computed: {
    ...mapState({
      stateIsLoad: (state) => state.isLoad,
      stateUserId: (state) => state.userId,
      stateIsLogin: (state) => state.isLogin,
      stateContCourseData: (state) => state.contCourseData,
      stateSelectAll: (state) => state.selectAll,
      scrollPosition: (state) => state.scrollPosition,
      isChangeRawProduct: (state) => state.isChangeRawProduct,
      forcedReload: (state) => state.forcedReload,
    }),
    phone() {
      return this.contCourseData?.account_info?.phone || "";
    },
    showExpand() {
      if (this.contCourseData.cnt_list?.length < 2) {
        return false;
      } else {
        return this.contCourseData.cnt_list?.some((listItem) => {
          return (
            listItem?.isEmptyCourseCard &&
            !this.shouldAlwaysShowCntTab(listItem)
          );
        });
      }
    },
    // 已购买的课程id
    purchasedCourseIds() {
      let course_ids = [];
      let optionsPackageInfo = [];
      let list = [
        ...(this.contCourseData.cnt_list || []),
        ...(this.contCourseData.recom_list || []),
      ];
      for (let item of list) {
        const options = item.package_info.filter((packageItem) => {
          return packageItem.status.id === 3;
        });
        optionsPackageInfo = optionsPackageInfo.concat(options);
      }
      for (let item of optionsPackageInfo) {
        course_ids.concat(
          item?.product_list
            .filter((p) => {
              return p.type === 100;
            })
            .map((p) => {
              course_ids.push(p.id);
            }) || []
        );
      }
      return course_ids;
    },

    selectCourseIds() {
      let course_ids = [];
      const optionsPackageInfo = this.getOptionsPackageInfo();
      // 获取所有已选中的数据
      const selectPackageInfo = optionsPackageInfo.filter(
        (packageItem) => packageItem.selectType === 2
      );
      for (let item of selectPackageInfo) {
        course_ids.concat(
          item?.product_list
            .filter((p) => {
              return p.type === 100;
            })
            .map((p) => {
              course_ids.push(p.id);
            }) || []
        );
      }
      return course_ids;
    },
  },
  data() {
    return {
      recomLeanCourseMap: {},
      contCourseData: {
        account_info: {}, // 用户信息 （手机号）
        expand_subject_ids: [], // 扩科学科id
        cnt_list: [], // 续报课
        recom_list: [], //推荐课列表
      },
      mustCheckBtn: false, // 全选按钮是否必须勾选
      isLoading: false, // 是否加载中
      error: {
        // 报错信息
        show: false,
        text: "",
      },
      dialog: {
        show: false,
        title: "",
        contents: [],
      },
      checkData: {}, // 勾选接口返回的数据
      disabledBuy: false,
      disabledSelectAll: false,
      showClashTip: false, // 展示底部冲突提示
      // selectCourseIds: [], // 选中的课程id
      selectClassIds: [], // 选中的班级id
      unSelectCourseIds: [], // 未选中的id
      loadCoursePackageEnding: false, // 课包内容是否加载完
      discount: {}, // 优惠信息 加价购购买的时候获取idencode使用
      pageLoadTimer: null, // 页面曝光埋点定时器
      pageLoadAllTime: 0, // 页面曝光累计时长
    };
  },
  methods: {
    ...mapMutations([
      "SET_CONT_COURSE",
      "SET_SELECT_ALL",
      "SET_ISLOGIN",
      "SET_SELECT_COURSE_IDS",
      "SET_SELECT_CLASS_IDS",
      "SET_SCROLL_POSITION",
      "setIsLoad",
      "SET_IS_CHANGE_RAW_PRODUCT",
      "setForcedReload",
      "SET_REC_LIST",
    ]),
    ...mapActions({
      checkLogin: "getIsLogin",
    }),
    shouldAlwaysShowCntTab(tabItem) {
      return (
        +tabItem?.title_info?.selection_info?.selection_mode === 2 &&
        !(tabItem?.package_info?.length > 0)
      );
    },
    // 获取初始化数据
    async init() {
      this.isLoading = true;
      const {
        stat = 0,
        msg = "",
        data = {},
      } = await getContCourseIndex({ brand: 1 }); // 获取接口数据
      try {
        if (+stat) {
          this.isLoading = false;
          if (data && Object.keys(data).length > 0) {
            setStuCourseIds(data.cnt_list || []);
            this.contCourseData = {
              ...data,
              cnt_list: data.cnt_list.map((item) => {
                return {
                  ...item,
                  package_info: transfromGoodsInfo(item.package_info),
                };
              }),
              recom_list: data.recom_list.map((item) => {
                return {
                  ...item,
                  package_info: transfromGoodsInfo(item.package_info),
                };
              }),
            };
            this.getRecommendLeaningCourse();
            // 设置选中状态，冲突提示，冲突状态
            if (this.contCourseData.cnt_list?.length > 0) {
              this.handleInitCourseCard(this.contCourseData.cnt_list, "raw");
            }
            if (this.contCourseData.recom_list?.length > 0) {
              // 设置推荐课程的依赖
              this.setRecomDependent();
              this.handleInitCourseCard(
                this.contCourseData.recom_list,
                "recom"
              );
            }
            // 判断加载完成
            this.loadCoursePackageEnding = true;
            this.setStatus();
            this.setIsLoad(false);
            // 埋点
            selectAllPoint("auto", this.stateSelectAll, this.stateUserId);
            loadPoint(
              this.$route.query?.source_id,
              this.selectCourseIds,
              this.stateUserId
            );
          }
        } else {
          this.$toast({ message: msg, className: "extension-signup-toast" });
        }
      } catch (error) {
        this.isLoading = false;
        console.log("error=== 1", error);
        throw new Error(error);
      }
      this.defaultCourseCheck();
    },
    // 获取已选主商品的id和type
    getSelectedCntList() {
      const optionsPackageInfo = this.getRawOptionsPackageInfo();
      // 获取所有已选中主商品
      const selectPackageInfo = optionsPackageInfo?.filter(
        (packageItem) => packageItem.selectType === 2
      );
      const selected_cnt_list = [];
      for (let item of selectPackageInfo) {
        selected_cnt_list.push({
          product_id: item.product_id,
          product_type: item.product_type,
        });
      }
      return selected_cnt_list;
    },
    // 获取加价购商品
    async getAddPriceBuy(options) {
      // 没有主商品不请求加价购的接口
      if (
        this.contCourseData?.cnt_list?.length === 0 &&
        this.contCourseData?.recom_list?.length === 0
      ) {
        return;
      }
      try {
        if (!options?.hiddenLoading) {
          this.isLoading = true;
        }
        // 从 cnt_list 获取所有商品数据
        const rec_list = [];
        this.contCourseData?.cnt_list?.map((item) => {
          for (let packageItem of item.package_info) {
            rec_list.push(
              `${packageItem?.product_type}_${packageItem?.product_id}`
            );
          }
        });
        // 添加推荐课程中非加价购商品
        this.contCourseData?.recom_list
          ?.filter((item) => !item.isAddPriceBuy)
          .map((item) => {
            for (let packageItem of item.package_info) {
              rec_list.push(
                `${packageItem?.product_type}_${packageItem?.product_id}`
              );
            }
          });
        // 保存到 store
        this.SET_REC_LIST(rec_list);
        const params = {
          brand: 1,
          expand_subject_ids: this.contCourseData?.expand_subject_ids || [],
          rec_list,
        };
        params.product_info = this.getSelectedCntList();
        // 根据选中的主课程 请求对应的加价购的课程
        const {
          data: addPriceBuyData = {},
          stat,
          msg,
        } = await getAddPriceBuyList(params);
        this.isLoading = false;
        if (+stat === 1) {
          const valueBuyList = this.formatValueBuyList(addPriceBuyData);
          if (valueBuyList.length > 0) {
            const selectTypeMap = this.getAddPriceBuySelectTypeMap();
            this.handleInitCourseCard(valueBuyList, "recom");
            this.applyAddPriceBuySelectType(valueBuyList, selectTypeMap);
            this.contCourseData.recom_list = this.contCourseData.recom_list
              .filter((item) => !item.isAddPriceBuy)
              .concat(valueBuyList);
            this.setStatus();
            return;
          }
          const groupAddPriceBuyList =
            this.formatGroupAddPriceBuyList(addPriceBuyData);
          const addPriceBuyList = addPriceBuyData.list || groupAddPriceBuyList;
          if (!addPriceBuyList?.length) {
            this.contCourseData.recom_list =
              this.contCourseData.recom_list.filter(
                (item) => !item.isAddPriceBuy
              );
            this.setStatus();
            return;
          }
          // 加价购商品数据format
          this.handleInitCourseCard(addPriceBuyList, "recom");
          // 标记加价购商品、保留原有的加价购商品的勾选状态
          const recomProductIdObj = getAllRecomIdObj(
            this.contCourseData.recom_list
          );
          const formatData = addPriceBuyList
            ?.filter(
              (item) =>
                item.product_key !== "_" && !recomProductIdObj[item.product_key]
            ) // 1.去除异常数据  2.同时命中加价购配置和推荐配置，优先展示推荐配置，做去重处理
            ?.map((item, index) => {
              const package_info = this.contCourseData?.recom_list?.find(
                (info) => info?.product_key === item?.product_key
              )?.package_info;
              // 默认勾选  不可购买的状态
              if (!package_info) {
                item.package_info?.forEach((info) => {
                  // 设置选中态
                  setSelectType(
                    info,
                    item.title_info?.check_status || item.title_info?.must_check
                  );
                });
              }
              return {
                ...item,
                isAddPriceBuy: true,
                package_info: (package_info || item.package_info)?.map(
                  (info) => ({
                    ...info,
                    parent: info.parent || item.parent,
                    isAddPriceBuy: true,
                    promotion_id: item.title_info?.promotion_id,
                    addPriceBuyIndex: index, // 扩科的第几位
                    default_check_states:
                      item.title_info?.check_status ||
                      item.title_info?.must_check,
                  })
                ),
              };
            });
          if (addPriceBuyList) {
            // 添加加价购课程到推荐课程列表中
            this.contCourseData.recom_list = this.contCourseData.recom_list
              .filter((item) => !item.isAddPriceBuy)
              .concat(formatData);
            this.setStatus();
          }
        } else {
          this.$toast(msg);
        }
      } catch (error) {
        console.log("error", error);
        this.isLoading = false;
      }
    },
    getAddPriceBuySelectTypeMap() {
      const selectTypeMap = {};
      this.contCourseData?.recom_list
        ?.filter((item) => item.isAddPriceBuy)
        .forEach((item) => {
          item.package_info?.forEach((packageItem) => {
            const productId = packageItem.product_id || packageItem.id;
            const productType = packageItem.product_type || packageItem.type;
            selectTypeMap[`${productType}_${productId}`] = {
              selectType: packageItem.selectType,
              selectTime: packageItem.selectTime || 0,
            };
          });
        });
      return selectTypeMap;
    },
    applyAddPriceBuySelectType(list, selectTypeMap) {
      list.forEach((item) => {
        item.package_info?.forEach((packageItem) => {
          const key = `${packageItem.product_type}_${packageItem.product_id}`;
          if (selectTypeMap[key]) {
            this.$set(packageItem, "selectType", selectTypeMap[key].selectType);
            if (selectTypeMap[key].selectTime) {
              this.$set(
                packageItem,
                "selectTime",
                selectTypeMap[key].selectTime
              );
            }
          } else if (packageItem.checked && packageItem.selectType === 1) {
            this.$set(packageItem, "selectType", 2);
          }
        });
      });
    },
    formatGroupAddPriceBuyList(addPriceBuyData = {}) {
      const groups = (addPriceBuyData.groups || []).filter(
        (group) => +group.rule_type === 1
      );
      if (groups.length === 0) {
        return [];
      }
      return groups
        .map((group) => {
          const groupItemKeys = this.getGroupItemKeys(group);
          const packages = (addPriceBuyData.items || [])
            .filter((item) => {
              const productId = item.product_id || item.id;
              const productType = item.product_type || item.type;
              return groupItemKeys.includes(`${productType}_${productId}`);
            })
            .map((item, index) =>
              this.normalizeGroupPackage(item, group, index)
            );
          if (packages.length === 0) {
            return null;
          }
          return {
            product_key:
              packages.length === 1
                ? packages[0].product_key
                : `group_${group.promotion_id || ""}`,
            title_info: {
              promotion_id: group.promotion_id,
              check_status: false,
              must_check: 0,
              select_limit: group.select_limit || 1,
              total_num: group.total_num || packages.length,
              subtitle: group.subtitle || "",
            },
            package_info: packages,
          };
        })
        .filter(Boolean);
    },
    formatValueBuyList(addPriceBuyData = {}) {
      const firstGroup = addPriceBuyData.groups?.[0];
      if (+firstGroup?.rule_type !== 2) {
        return [];
      }
      const packages = this.getGroupOrderedItems(
        firstGroup,
        addPriceBuyData.items
      ).map((item, index) =>
        this.normalizeGroupPackage(item, firstGroup, index)
      );
      if (packages.length === 0) {
        return [];
      }
      return [
        {
          isAddPriceBuy: true,
          isValueBuyGroup: true,
          product_key: `value_buy_${firstGroup.promotion_id || ""}`,
          title_info: {
            promotion_id: firstGroup.promotion_id,
            check_status: false,
            must_check: 0,
            select_limit: firstGroup.select_limit || 1,
            total_num: firstGroup.total_num || packages.length,
            act_desc: addPriceBuyData.act_desc || "",
            subtitle: firstGroup.subtitle || "",
          },
          package_info: packages,
        },
      ];
    },
    getGroupItemKeys(group = {}) {
      return (group.item_ids || []).map(
        (item) => `${item.product_type}_${item.product_id}`
      );
    },
    getGroupOrderedItems(group = {}, items = []) {
      const itemMap = (items || []).reduce((result, item) => {
        const productId = item.product_id || item.id;
        const productType = item.product_type || item.type;
        result[`${productType}_${productId}`] = item;
        return result;
      }, {});
      return this.getGroupItemKeys(group)
        .map((key) => itemMap[key])
        .filter(Boolean);
    },
    getParentProductText(item = {}) {
      return (item.parent_product_list || [])
        .map(
          (parentItem) =>
            `${parentItem.parent_product_type}_${parentItem.parent_product_id}`
        )
        .join(",");
    },
    normalizeGroupPackage(item, group, index) {
      const productId = item.product_id || item.id;
      const productType = item.product_type || item.type;
      return {
        ...item,
        id: item.id || productId,
        product_id: productId,
        product_type: productType,
        product_key: `${productType}_${productId}`,
        parent: this.getParentProductText(item),
        product_list: (item.product_list || []).map((product) => ({
          ...product,
          type: product.type || product.product_type,
        })),
        gift_list: item.gift_list || [],
        suit_list: item.suit_list || [],
        pic_url: item.pic_url || [],
        price: item.price || {},
        status: item.status || {},
        isAddPriceBuy: true,
        promotion_id: group.promotion_id,
        addPriceBuyIndex: index,
        valueBuyGroupKey: `value_buy_${group.promotion_id || ""}`,
        valueBuySelectLimit: group.select_limit || 1,
        default_check_states: false,
      };
    },
    async defaultCourseCheck() {
      // 选中主课程
      const optionsPackageInfo = this.getRawOptionsPackageInfo();
      this.handleCheckBatch(true, optionsPackageInfo);
      // 根据选中的主课程 请求对应的加价购的课程
      await this.getAddPriceBuy({ hiddenLoading: true }); // 首次加载隐藏loading 加快页面加载速度
      // 判断是不是有需要选中的推荐课程
      const optionsDefaultCheck = this.getRecomdDefaultCheck();
      this.handleCheckBatch(true, optionsDefaultCheck);
      // 一起去发请求
      this.handleFetchCheckBatch();
    },
    // 获取推荐课程需要默认勾选的课程
    getRecomdDefaultCheck() {
      const list = this.contCourseData.recom_list || [];
      // 筛选出可以操作的数据，selectType !==3
      let optionsPackageInfo = [];
      for (let item of list) {
        const options = item.title_info.check_status
          ? item.package_info.filter((packageItem) => {
              return packageItem.selectType !== 3;
            })
          : [];
        optionsPackageInfo = optionsPackageInfo.concat(options);
      }
      return optionsPackageInfo;
    },
    // 筛选符合的课程
    filterPackageInfo(list, filterMustCheck) {
      // filterMustCheck 为true时，过滤掉必须勾选的课程
      let inner_list = list;
      if (filterMustCheck) {
        inner_list = list.filter((item) => {
          return item.title_info?.must_check !== 1;
        });
      }
      // 筛选出可以操作的数据，selectType !==3
      let optionsPackageInfo = [];
      for (let item of inner_list) {
        const options = item.package_info.filter(
          (packageItem) => packageItem.selectType !== 3
        );
        optionsPackageInfo = optionsPackageInfo.concat(options);
      }
      return optionsPackageInfo;
    },
    // 设置推荐课程依赖的课程 id
    setRecomDependent() {
      // 获取推荐课程对应的主课程依赖关系
      const list = this.contCourseData.recom_list || [];
      list.map((item) => {
        if (item?.title_info?.learn_course_id) {
          item.package_info.map((subItem) => {
            const { courseIds } = this.findCourseIdByLeanCourseId(
              item?.title_info?.learn_course_id
            );
            subItem.dependent = courseIds;
          });
        }
      });
    },
    //  设置推荐课程禁用状态
    setRecomSelectTypeByDependent() {
      // 设置推荐课程的选中状态
      const list = this.contCourseData.recom_list || [];
      // 判断课程是否可选择
      const isCourseSelectable = (buyType, courseIds) => {
        const selectAndPurchasedCourseIds = [
          ...this.selectCourseIds,
          ...this.purchasedCourseIds,
        ];
        switch (buyType) {
          case 0: // 不限制
            return true;
          case 1: // 续报
            return selectAndPurchasedCourseIds.includes(courseIds[0]);
          case 2: // 联报
            return courseIds.every((id) =>
              selectAndPurchasedCourseIds.includes(id)
            );
          default:
            return false;
        }
      };

      // 更新 package_info 中的 selectType
      const updatePackageSelectType = ({
        packages,
        canSelect,
        courses,
        learn_course_id,
      }) => {
        const selectType = canSelect ? 1 : 3;
        let coursesName = "";
        if (courses) {
          coursesName = courses.map((c) => c.name).join("和</br>");
        }
        let template = `需购买${coursesName}才可购买本课程`;
        packages.forEach((packageItem) => {
          if (packageItem.originalSelectType !== 3) {
            packageItem.selectType = selectType;
            if (!canSelect) {
              packageItem.buy_limit_msg = template;
              packageItem.learn_course_id = learn_course_id;
            }
          }
        });
      };

      list.forEach((item) => {
        const { buy_limit: buyType, learn_course_id } = item.title_info || {};
        let { courseIds, courses } = learn_course_id
          ? this.findCourseIdByLeanCourseId(learn_course_id)
          : {
              courseIds: [],
              courses: [],
            };
        courses =
          buyType === 1 ? (courses.length > 0 ? [courses[0]] : []) : courses;
        const canSelect = learn_course_id
          ? isCourseSelectable(buyType, courseIds)
          : item.isAddPriceBuy // 加价购的初始化的时候处理了，这里直接返回true即可
          ? true
          : false;

        if (canSelect) {
          if (item.package_info.every((p) => p.selectType === 3)) {
            updatePackageSelectType({
              packages: item.package_info,
              learn_course_id,
              canSelect,
            });
          }
        } else {
          updatePackageSelectType({
            packages: item.package_info,
            canSelect,
            learn_course_id,
            courses,
          });
        }
      });
    },

    // 获取推荐课程对应的主课程依赖关系
    getRecommendLeaningCourse() {
      const list = this.contCourseData.recom_list || [];
      const recomLeanCourseMap = {};
      list.map((item) => {
        if (item?.title_info?.learn_course_id) {
          const { courseIds } = this.findCourseIdByLeanCourseId(
            item?.title_info?.learn_course_id
          );
          recomLeanCourseMap[item?.title_info?.learn_course_id] = courseIds;
        }
      });
      this.recomLeanCourseMap = recomLeanCourseMap;
    },
    // 根据learn_course_id找到对应的product_list的id
    findCourseIdByLeanCourseId(leanCourseId) {
      const list = this.contCourseData.cnt_list || [];
      const courseIds = [];
      const courses = [];
      for (let item of list) {
        if (item.title_info.learn_course_id === leanCourseId) {
          item.package_info.map((subItem) => {
            subItem?.product_list
              .filter((p) => p.type === 100)
              .map((p) => {
                courseIds.push(p.id);
                courses.push(p);
              });
          });
        }
      }
      return {
        courseIds,
        courses,
      };
    },
    // 获取可操作全部课程的packageInfo
    getOptionsPackageInfo(filterMustCheck) {
      const list = [
        ...(this.contCourseData.cnt_list || []),
        ...(this.contCourseData.recom_list || []),
      ];
      return this.filterPackageInfo(list, filterMustCheck);
    },
    updatePackageSelectTime(
      packageItem,
      nextSelectType,
      timestamp = Date.now()
    ) {
      if (!packageItem?.valueBuyGroupKey) {
        return;
      }
      if (+nextSelectType === 2) {
        this.$set(packageItem, "selectTime", timestamp);
        return;
      }
      this.$delete(packageItem, "selectTime");
    },
    sortSelectedPackageInfo(packageInfoList = []) {
      return packageInfoList
        .map((packageItem, index) => ({
          packageItem,
          index,
        }))
        .sort((prev, next) => {
          const prevIsValueBuy = !!prev.packageItem?.valueBuyGroupKey;
          const nextIsValueBuy = !!next.packageItem?.valueBuyGroupKey;
          if (prevIsValueBuy && nextIsValueBuy) {
            const prevTime = prev.packageItem?.selectTime || 0;
            const nextTime = next.packageItem?.selectTime || 0;
            if (prevTime !== nextTime) {
              return prevTime - nextTime;
            }
          }
          return prev.index - next.index;
        })
        .map(({ packageItem }) => packageItem);
    },
    // 获取推荐课程的packageInfo
    getRecomOptionsPackageInfo(filterMustCheck) {
      const list = this.contCourseData.recom_list || [];
      return this.filterPackageInfo(list, filterMustCheck);
    },
    // 获取可操作的主课程packageInfo
    getRawOptionsPackageInfo(filterMustCheck) {
      const list = this.contCourseData.cnt_list || [];
      // 筛选出可以操作的数据，selectType !==3
      return this.filterPackageInfo(list, filterMustCheck);
    },
    // 判断是联报还是续报
    // 设置一些展示状态：是否已经全选，footer购买按钮是否置灰，footer全选按钮是否置灰
    setStatus() {
      let selectAll = false; // 判断是否全选
      let availableSale = false; // 判断立即购买按钮是否置灰
      const optionsPackageInfo = this.getOptionsPackageInfo();
      console.log("optionsPackageInfo--", optionsPackageInfo);
      // 设置不可选状态，判断所有数据是否都为不可选
      this.disabledSelectAll = optionsPackageInfo.length === 0;
      const list = [
        ...(this.contCourseData.cnt_list || []),
        ...(this.contCourseData.recom_list || []),
      ];
      // 若每一项都必须勾选，那么全选按钮也必须勾选
      this.mustCheckBtn = list.every((item) => {
        return item.title_info?.must_check === 1;
      });
      // 若每一个能勾选的数据全部被勾选，那么判断为已经全选
      selectAll = optionsPackageInfo.every((packageItem) => {
        return packageItem.selectType === 2;
      });
      this.SET_SELECT_ALL(this.disabledSelectAll ? false : selectAll);
      // 所有可以操作的课程都为待开售状态 || 没有可操作数据，那么购买按钮置灰
      availableSale = optionsPackageInfo.every((packageItem) => {
        return +packageItem.selectType !== 2;
      });
      this.disabledBuy = availableSale;
      // 保存选中的课程id
      this.SET_CONT_COURSE(this.contCourseData);
    },
    /* 完善卡片信息数据 增加字段*/
    handleInitCourseCard(contCourseData, cardType) {
      // listItem为cnt_list 或 recom_list的一项
      for (let listItem of contCourseData) {
        formatData(
          listItem,
          listItem.title_info?.check_status || listItem.title_info?.must_check
        );
        for (let packageItem of listItem.package_info) {
          this.$set(packageItem, "cardType", cardType);
        }
      }
    },
    // 勾选后处理与已报名课程时间冲突
    checkClash(schedule) {
      this.showClashTip = schedule?.length > 0;
      // schedule = [{course_id:'',msg:''}]
      // 根据schedule中的course_id，找到对应的package_info的一项，将isClash置为true，clashMsg置为msg
      const optionsPackageInfo = this.getOptionsPackageInfo();
      for (let package_info of optionsPackageInfo) {
        const courseIds = package_info.product_list.map((item) => item.id);
        const scheduleItem = schedule.find((s) =>
          courseIds.includes(s.course_id)
        );
        if (scheduleItem) {
          this.$set(package_info, "isClash", true);
          this.$set(package_info, "clashMsg", scheduleItem.msg);
        } else {
          this.$set(package_info, "isClash", false);
          this.$set(package_info, "clashMsg", "");
        }
      }
      // 找出cnt_list中包含isClash的package_info，若存在则将cnt_list中的isClash置为true
      const list = [
        ...(this.contCourseData.cnt_list || []),
        ...(this.contCourseData.recom_list || []),
      ];
      for (let item of list) {
        const p = item.package_info.find((p) => p.isClash);
        if (p) {
          this.$set(item, "isClash", true);
          this.$set(item, "clashMsg", p.clashMsg);
        } else {
          this.$set(item, "isClash", false);
          this.$set(item, "clashMsg", "");
        }
      }
    },
    // 检查冲突逻辑
    async checkSelectItem() {
      // 设置推荐课程的选中状态
      this.setRecomSelectTypeByDependent();
      const optionsPackageInfo = this.getOptionsPackageInfo();
      // 获取所有已选中的数据
      const selectPackageInfo = this.sortSelectedPackageInfo(
        optionsPackageInfo.filter((packageItem) => packageItem.selectType === 2)
      );
      // 若没有已经选择的数据，那么不执行请求，直接将checkData置空，金额展示为0
      if (selectPackageInfo.length === 0) {
        this.checkData = {};
        this.checkClash([]);
        return;
      }
      const params = {
        // product_id: package_info.id   product_type: package_info.product_type
        product_info: [],
        course_ids: [], // 课程id
      };
      for (let item of selectPackageInfo) {
        const info = {};
        if (item.product_type === 100) {
          info.subject_id = item?.product_list?.[0]?.extra_info?.subject_id;
          info.term_id = item?.product_list?.[0]?.extra_info?.term_ids;
        }
        info.resale = item.price.sale_price;
        params.product_info.push({
          product_id: item.product_id,
          product_type: item.product_type,
          parent: item.parent,
          info,
        });
        params.course_ids = params.course_ids.concat(
          item?.product_list.filter((p) => p.type === 100).map((p) => p.id) ||
            []
        );
      }

      this.isLoading = true;
      console.log("params---", params);
      const { stat = 0, msg = "", data = {} } = await postCheckIndex(params);
      try {
        this.isLoading = false;
        if (+stat) {
          if (data && Object.keys(data).length > 0) {
            this.checkData = data;
            this.checkClash(data.schedule || []);
            // 计价接口返回的价格是到手价
            setBuyPrice(
              this.contCourseData?.cnt_list,
              data.promotion?.product_info || []
            );
            setBuyPrice(
              this.contCourseData?.recom_list,
              data.promotion?.product_info || []
            );
            if (data.promotion.discount) {
              this.discount = data.promotion?.discount;
            }
          }
        } else {
          this.$toast({ message: msg, className: "extension-signup-toast" });
        }
      } catch (error) {
        this.isLoading = false;
        console.log("error=== 2", error);
      }
    },
    // 主课程全选
    async handleCheckAllRaw(bool) {
      console.log("执行主课程全选逻辑---", bool);
      // 将contCourseData中所有selectType为1的都修改为2
      const optionsPackageInfo = this.getRawOptionsPackageInfo();
      this.handleCheckBatch(bool, optionsPackageInfo);
      this.handleFetchCheckBatch();
    },
    /*
    全选
    拆分成主课程和推荐课程两个部分
    为了应对推荐课程的依赖关系，需要先勾选主课程 再去判断推荐课程的选中状态 再去勾选
    */
    async handleCheckAll(bool) {
      console.log("执行全选逻辑---", bool);
      // 主课程
      const rawOptionsPackageInfo = this.getRawOptionsPackageInfo(!bool);
      this.handleCheckBatch(bool, rawOptionsPackageInfo);
      // 主商品勾选状态发生变化 重新请求加价购的商品
      await this.getAddPriceBuy();
      this.setRecomSelectTypeByDependent();
      // 推荐课程
      const recomOptionsPackageInfo = this.getRecomOptionsPackageInfo(!bool);
      this.handleCheckBatch(bool, recomOptionsPackageInfo);
      // 将contCourseData中所有selectType为1的都修改为2
      this.handleFetchCheckBatch();
    },
    handleCheckBatch(bool, optionsPackageInfo) {
      console.log("optionsPackageInfo--", optionsPackageInfo);
      const timestamp = Date.now();
      for (let [index, packageItem] of optionsPackageInfo.entries()) {
        // 若为全选将1改为2
        if (bool) {
          if (packageItem.selectType === 1) {
            this.$set(packageItem, "selectType", 2);
            this.updatePackageSelectTime(packageItem, 2, timestamp + index);
          }
        } else {
          // 若为取消全选将2改为1
          if (packageItem.selectType === 2) {
            this.$set(packageItem, "selectType", 1);
            this.updatePackageSelectTime(packageItem, 1);
          }
        }
      }
    },
    async handleFetchCheckBatch() {
      await this.checkSelectItem();
      this.setStatus(); // 这个方法中包含setContCourse
      selectAllPoint("touch", this.stateSelectAll, this.stateUserId);
    },
    async handleSelectionModeConfirm({ cardType }) {
      this.getRecommendLeaningCourse();
      this.setRecomDependent();
      if (cardType === "raw") {
        await this.getAddPriceBuy({ hiddenLoading: true });
      }
      await this.checkSelectItem();
      this.setStatus();
    },
    // 选中/取消某一项数据
    async handleCheckOne(package_info) {
      console.log("package_info---", package_info);
      const nextSelectType = package_info.selectType === 1 ? 2 : 1;
      this.$set(package_info, "selectType", nextSelectType);
      this.updatePackageSelectTime(package_info, nextSelectType);
      // 主商品勾选状态发生变化 重新请求加价购的商品
      if (package_info.cardType === "raw") {
        await this.getAddPriceBuy();
      }
      // 检查是否有冲突数据
      await this.checkSelectItem();
      this.setStatus(); // 这个方法中包含setContCourse
      singleSelectPoint(
        true,
        "click-selectcourse",
        package_info,
        this.stateUserId,
        this.discount
      );
    },
    async buyOld(param) {
      try {
        const { data = {} } = await postIsCanBuy(param);
        if (data?.idEncode) {
          const idEncode = data.idEncode;
          let url = `https://trade.xueersi.com/Order/confirm?idEncode=${idEncode}`;
          if (this.$route.query?.source_id) {
            url = `${url}&sourceId=${this.$route.query?.source_id}`;
          }
          window.location.href = url;
        } else {
          if (data.content) {
            this.dialog.show = true;
            this.dialog.title = data.msg || data;
            this.dialog.contents = data.content;
          } else {
            this.$toast(data.msg || "无法获取订单信息失败，请稍后重试");
          }
        }
      } catch (error) {
        console.log("buyOld error===", error);
      }
    },
    async goBuy(param) {
      try {
        const { data = {}, code, msg } = await idEncode(param);
        if (data?.id_encode) {
          const idEncode = data.id_encode;
          console.log("data----", data);
          this.setForcedReload(true); // 设置返回时刷新
          window.location.href = `https://trade.xueersi.com/goodspay/#/order-confirm?id_encode=${encodeURIComponent(
            idEncode
          )}`;
        } else {
          if (data.content) {
            this.dialog.show = true;
            this.dialog.title = data.msg || data;
            this.dialog.contents = data.content;
          } else {
            if (+code === 400) {
              // 极端情况下出现问题，显示兜底的报错
              this.$toast("系统繁忙，请稍后重试");
            } else {
              this.$toast(
                msg || data.msg || "无法获取订单信息失败，请稍后重试"
              );
            }
          }
        }
      } catch (error) {
        console.log("error=== 3", error);
      }
    },
    // 执行分享埋点
    handleSharePoint() {
      sharePoint(this.stateUserId);
    },
    /* 处理登录弹窗*/
    handleLoginPop() {
      loginPopUp(this);
    },
    /* 登出 */
    handleLogout() {
      logout();
    },
    pageLoad({ isInit }) {
      let current_id = sessionStorage.getItem("page_load_current_id");
      if (!current_id) {
        current_id = uuidv4();
        sessionStorage.setItem("page_load_current_id", current_id);
      }
      const increase_list = (this.contCourseData?.recom_list || []).filter(
        (item) => item.isAddPriceBuy
      );
      this.$xesLogger.loadMsg({
        ...appendStuCourseIds(
          {
            show_id: "show_M5PkJBwr",
            show_name: "页面曝光",
            current_id,
            isInit,
            allTime: this.pageLoadAllTime,
            eventtype: "stay",
            respos_type2_launch: increase_list.length ? 1 : 2, // 是否有扩科资源位推出
          },
          this.contCourseData
        ),
      });
    },
  },
  watch: {
    // contCourseData: {
    //   handler(val) {
    //     console.log("0000000---", JSON.stringify(val));
    //     if (val.recom_list) {
    //       this.setRecomSelectTypeByDependent();
    //     }
    //   },
    //   deep: true,
    // },
    stateIsLogin: {
      immediate: true,
      handler(val) {
        // 这里其实是初始化的逻辑，判断登录后执行这里的操作
        if (val || this.$isLoginFree) {
          if (
            this.stateIsLoad &&
            (window.performance?.navigation?.type === 1 ||
              window.performance?.navigation?.type === 0)
          ) {
            console.log("refresh || init---重新调取接口");
            this.init();
          } else {
            if (this.forcedReload) {
              location.reload();
              this.setForcedReload(false);
            } else {
              this.contCourseData = cloneDeep(this.stateContCourseData);
              this.loadCoursePackageEnding = true;
              this.$nextTick(async () => {
                if (this.isChangeRawProduct) {
                  //主课更换了课程  需要重新获取加价购的商品
                  await this.getAddPriceBuy();
                  this.SET_IS_CHANGE_RAW_PRODUCT(false);
                }
                await this.checkSelectItem();
                this.setStatus(); // 这个方法中包含setContCourse
                if (Object.keys(this.$route?.params || {}).length > 0) {
                  positionCard(this);
                } else {
                  document.documentElement.scrollTop = this.scrollPosition;
                }
              });
              console.log("走了页面缓存cache------");
            }
          }
        }
      },
    },
  },
  async created() {
    if (this.$isLoginFree) return;
    const res = await this.checkLogin();
    console.log("login---res", res);
  },
  mounted() {
    this.pageLoad({ isInit: "1" });
    this.pageLoadTimer = setInterval(() => {
      this.pageLoadAllTime += 3;
      this.pageLoad({ isInit: "0" });
    }, 3000);
    if (this.$isInApp) {
      WXJsBridge?.setNavigationBar({ hidden: 1 });
    }
    // 选择某一条数据时触发
    this.$EventBus.$on("selectOne", (package_info) => {
      this.handleCheckOne(package_info);
    });
    this.$EventBus.$on("selectionModeConfirm", (payload) => {
      this.handleSelectionModeConfirm(payload);
    });
  },
  beforeRouteLeave(to, from, next) {
    console.log("执行beforeRouteLeave----");
    clearInterval(this.pageLoadTimer);
    let scrollPosition = window.scrollY || document.documentElement.scrollTop;
    console.log("scrollPosition--", scrollPosition);
    this.SET_SCROLL_POSITION(scrollPosition);
    next();
  },
  beforeDestroy() {
    this.$EventBus.$off("selectOne");
    this.$EventBus.$off("selectionModeConfirm");
  },
};
</script>
<style lang="less">
.extension-signup-toast {
  font-size: 16px !important;
  line-height: 22px !important;
  background-color: rgba(0, 0, 0, 0.8) !important;
  padding: 14px 20px !important;
}
@keyframes flash {
  0% {
    background-color: #fff;
  }
  100% {
    background-color: red;
  }
}
.twinkle {
  animation: flash 800ms linear 6 alternate;
  /* 其他样式 */
}
</style>
<style lang="less" scoped>
// @import '@/common/css/common.less';
.extension-signup-content {
  box-sizing: border-box;
  min-height: 100vh;
  padding: 1px 0;
  background-image: url("https://editor.xesimg.com/tailor/resource/page-head-bg-1761126038083.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center top;
  background-color: #f7f7f8;

  .extension-signup-content-list {
    width: 100%;
    margin-top: 5px;
    padding: 0 12px;
    box-sizing: border-box;
    border-radius: 16px;
    padding-bottom: calc(72px + constant(safe-area-inset-bottom));
    padding-bottom: calc(72px + env(safe-area-inset-bottom));
  }
}
</style>
